import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL || 'http://192.168.29.142:5001/api',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
  fetchFn: async (input, init) => {
    // If body is FormData, don't set Content-Type header
    if (init?.body instanceof FormData) {
      // Remove Content-Type to let browser set it with boundary
      if (init.headers) {
        if (init.headers instanceof Headers) {
          init.headers.delete('content-type');
        } else if (typeof init.headers === 'object') {
          delete init.headers['content-type'];
          delete init.headers['Content-Type'];
        }
      }
    }
    return fetch(input, init);
  },
});

const baseQuery = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('permissions');
    window.location.href = '/login';
  }
  return result;
};

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery,
  tagTypes: [
    'User',
    'Company',
    'Module',
    'Product',
    'Inventory',
    'Purchase',
    'PurchaseReturn',
    'Sales',
    'SalesHolds',
    'Customer',
    'Supplier',
    'Finance',
    'Report',
    'VanSales',
    'Role',
    'Quotation',
    'EmailTemplate',
    'Backup',
    'RegisterSession',
  ],
  endpoints: () => ({}),
});
